import _ from 'lodash'
import apiCall from './call'
import router from '@/router'
import fileDownload from '@/functions/fileDownload'
import {
  ACCOUNT_PUT,
  ACCOUNT_GET,
  ACCOUNT_DELETE,
  ACCOUNT_STATUS_SET,
  ACCOUNT_FILES_GET,
  ACCOUNT_FILE_GET,
  ACCOUNT_FILE_PUT,
  ACCOUNT_FILE_ACTION,
  ACCOUNT_FILE_GET_PREVIEW,
  ACCOUNT_FILE_UPDATE,
  ACCOUNT_FILES_DELETE,
  ACCOUNT_REFRESH_TOKEN,
  ACCOUNT_FILE_DETAILS,
  ACCOUNT_SHOW_TOUR,
  ACCOUNT_EXPORT_DOWNLOAD
} from '../actions/accounts'
import Cookies from 'js-cookie'

const model = 'accounts'

const state = {
  tourModalActive: false
}

const getters = {
  //
}

const actions = {
  [ACCOUNT_FILES_GET]: ({ commit, dispatch }, data) => {
    return new Promise((resolve, reject) => {
      apiCall({
        url: model + '/' + data.account_id + '/files',
        qs: data
      }).then(response => {
        commit('datatableIndex/setIndex', {
          'model': 'account_files',
          'index': response,
          'query': data
        })
        resolve(response)
      }).catch(err => {
        reject(err)
      })
    })
  },
  [ACCOUNT_FILE_GET]: ({ commit, dispatch }, data) => {
    return new Promise((resolve, reject) => {
      apiCall({ url: model + '/' + data.account_id + '/files/' + data.file_id })
        .then(response => {
          if (response.data === undefined) {
            fileDownload(response, data.file_name)
          }
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  [ACCOUNT_FILE_PUT]: ({ commit, dispatch }, data) => {
    return new Promise((resolve, reject) => {
      apiCall({
        url: '/account_files',
        method: 'POST',
        data: data
      })
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  [ACCOUNT_FILE_ACTION]: ({ commit, dispatch }, data) => {
    return new Promise((resolve, reject) => {
      apiCall({
        url: model + '/' + data.account_id + '/files/action',
        method: 'POST',
        data: data.params
      })
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  [ACCOUNT_FILE_GET_PREVIEW]: ({ commit, dispatch }, data) => {
    return new Promise((resolve, reject) => {
      apiCall({ url: model + '/' + data.account_id + '/files/' + data.file_id + '/preview' })
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  [ACCOUNT_FILE_UPDATE]: ({ commit, dispatch }, data) => {
    return new Promise((resolve, reject) => {
      apiCall({
        url: model + '/' + data.account_id + '/files/' + data.file_id,
        data: data,
        method: 'PATCH'
      })
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  [ACCOUNT_FILES_DELETE]: ({ commit, dispatch }, data) => {
    let files = { ids: data.ids }
    return new Promise((resolve, reject) => {
      apiCall(
        { url: model + '/' + data.account_id + '/files',
          data: files,
          method: 'DELETE'
        })
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  [ACCOUNT_GET]: ({ commit, dispatch }, accountId) => {
    return new Promise((resolve, reject) => {
      apiCall({ url: model + '/' + accountId })
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  [ACCOUNT_DELETE]: ({ commit, dispatch }, accountId) => {
    return new Promise((resolve, reject) => {
      apiCall({ url: model + '/' + accountId, method: 'DELETE' })
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  [ACCOUNT_STATUS_SET]: ({ commit, dispatch }, data) => {
    return new Promise((resolve, reject) => {
      apiCall({
        url: model + '/status',
        data: {
          account_id: data.accountId,
          status_id: data.statusId
        },
        method: 'PATCH'
      })
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  [ACCOUNT_PUT]: ({ commit, dispatch }, data) => {
    return new Promise((resolve, reject) => {
      apiCall({
        url: model + '/' + data.account_id,
        data: data,
        method: 'PUT'
      })
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  [ACCOUNT_REFRESH_TOKEN]: ({ commit, dispatch }, accountId) => {
    return new Promise((resolve, reject) => {
      apiCall({
        url: '/accounts/' + accountId + '/refresh-share-token',
        method: 'POST'
      })
        .then(response => {
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  [ACCOUNT_FILE_DETAILS]: ({ commit, dispatch }, data) => {
    return new Promise((resolve, reject) => {
      apiCall({
        url: model + '/' + data.account_id + '/files/' + data.file_id + '/details',
        qs: {
          sort: data.sort,
          order: data.order,
          search: data.search,
          'filter__sov': data['filter__sov']
        }
      }).then(response => {
        resolve(response)
      }).catch(err => {
        reject(err)
      })
    })
  },
  [ACCOUNT_SHOW_TOUR]: ({ commit, rootState }, data) => {
    if (rootState.init.all.auth_user.via_invite || rootState.init.all.auth_user.via_share_link) {
      let show = false
      if (data.type === 'Managed') {
        if (data.status.state !== 'uploading' && data.status.state !== 'processing') {
          show = true
        }
      } else {
        show = true
      }

      _.each(rootState.init.all.auth_user.roles, function (role) {
        if (role === 'upload_only') {
          show = false
          return false
        }
      })

      const cookieVal = Cookies.get('seenTour')
      if (show && !cookieVal) {
        commit('setAccountActiveTab', {
          'account_id': router.currentRoute.params.id,
          'tab': 0
        })
        commit('showTourModal')
      }
    }
  },
  [ACCOUNT_EXPORT_DOWNLOAD]: ({ commit, dispatch }, data) => {
    return new Promise((resolve, reject) => {
      apiCall({
        url: 'account_properties/' + data.model + '/download',
        data: {},
        method: 'POST',
        responseType: 'blob',
        withHeaders: true
      }).then(response => {
        const filenameHeader = response.headers['x-filename']

        if (filenameHeader) {
          return fileDownload(response.data, filenameHeader)
        }

        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  }
}

const mutations = {
  showTourModal (state) {
    state.tourModalActive = true
  },
  hideTourModal (state) {
    state.tourModalActive = false
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/account.js